var map = {
	"./Achtung.svg": 6494,
	"./Fahrerhausschalter.svg": 2485,
	"./Shift.svg": 5830,
	"./Zeichnung_2H.svg": 782,
	"./btnClose.svg": 8558,
	"./btnDown.svg": 4122,
	"./btnOpen.svg": 5410,
	"./btnPlatformIn.svg": 1594,
	"./btnPlatformOut.svg": 3533,
	"./btnTrailer.svg": 4159,
	"./btnTruck.svg": 4419,
	"./btnUp.svg": 8905,
	"./control_mode0.svg": 5131,
	"./control_mode1.svg": 4762,
	"./control_mode2.svg": 6137,
	"./control_mode3.svg": 4392,
	"./footswitch0.svg": 8666,
	"./footswitch1.svg": 9035,
	"./footswitch2.svg": 8296,
	"./footswitch3.svg": 3689,
	"./noDown.svg": 3275,
	"./noDown_Grau.svg": 7255,
	"./noUeberdruck.svg": 9209,
	"./noUeberdruck_Grau.svg": 261,
	"./noUp.svg": 2964,
	"./noUpDown.svg": 896,
	"./noUpDown_Grau.svg": 2234,
	"./noUp_Grau.svg": 8446,
	"./pls_orientation0.jpeg": 3773,
	"./pls_orientation1.jpeg": 5110,
	"./pls_orientation2.jpeg": 3171,
	"./pls_orientation3.jpeg": 892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;